import { useRef, useState } from "react";
import { ImageUpload } from "./common";

// Genel poligon editörü: value = [{label, points:[[x,y]...]}] (0-100 yüzde)
export function PolygonEditor({ image, onImage, value = [], onChange, labelSoru = "Etiket", testId }) {
  const ref = useRef();
  const [cizen, setCizen] = useState([]);
  const bg = image?.startsWith("data:") || image?.startsWith("http") ? image : image ? `${process.env.REACT_APP_BACKEND_URL}${image}` : "";

  const tikla = (e) => {
    if (!image) return;
    const r = ref.current.getBoundingClientRect();
    const x = +(((e.clientX - r.left) / r.width) * 100).toFixed(2);
    const y = +(((e.clientY - r.top) / r.height) * 100).toFixed(2);
    setCizen((c) => [...c, [x, y]]);
  };
  const kapat = () => {
    if (cizen.length < 3) return;
    const label = window.prompt(`${labelSoru}:`);
    if (label === null) return;
    onChange([...value, { label: label.trim(), points: cizen }]);
    setCizen([]);
  };
  const sil = (i) => onChange(value.filter((_, j) => j !== i));

  return (
    <div>
      <div style={{ marginBottom: 10 }}>
        <ImageUpload value={image} onChange={onImage} testId={`${testId}-img`} />
      </div>
      {image && (
        <>
          <div className="pg-arac" ref={ref} onClick={tikla} data-testid={`${testId}-tuval`}>
            <img src={bg} alt="Poligon zemini" />
            <svg viewBox="0 0 100 100" preserveAspectRatio="none">
              {value.map((pg, i) => (
                <g key={i}>
                  <polygon points={pg.points.map((p) => p.join(",")).join(" ")} fill="rgba(185,143,85,.3)" stroke="#B98F55" strokeWidth=".5" />
                </g>
              ))}
              {cizen.length > 0 && (
                <polyline points={cizen.map((p) => p.join(",")).join(" ")} fill="rgba(47,52,56,.25)" stroke="#2F3438" strokeWidth=".5" />
              )}
              {cizen.map((p, i) => <circle key={i} cx={p[0]} cy={p[1]} r="0.9" fill="#96703F" />)}
            </svg>
          </div>
          <div className="a-satir" style={{ marginTop: 10 }}>
            <span className="veri">{cizen.length} nokta</span>
            <button type="button" className="a-btn bal kucuk" onClick={kapat} disabled={cizen.length < 3} data-testid={`${testId}-kapat`}>Poligonu kapat</button>
            <button type="button" className="a-btn hayalet kucuk" onClick={() => setCizen([])}>Temizle</button>
          </div>
          <div style={{ marginTop: 12 }}>
            {value.map((pg, i) => (
              <div className="a-satir" key={i} style={{ borderBottom: "1px solid var(--cizgi)", padding: "6px 0" }}>
                <b style={{ fontFamily: "var(--veri)", fontSize: 12 }}>{pg.label}</b>
                <span className="veri">{pg.points.length} nokta</span>
                <button type="button" className="a-btn hayalet kucuk" onClick={() => sil(i)}>Sil</button>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
